import React, { useEffect } from 'react';

import { MessageFields } from '../../MessageFields';

import * as Styled from './MessageModal.styles';

import { ModalPortal } from '+/components/Modal/ModalPortal.component';
import { ModalBody } from '+/components/Modal/ModalBody.component';
import { t } from '+/utils/textDictionary';
import { useIsSmallMobile } from '+/utils/responsive';

export const requiredMessageModalFields = Object.freeze(['Subject0', 'Message0']);

export const MessageModal = ({
  messageModalData,
  onClose,
}: {
  messageModalData: MessageModalComponent;
  onClose: () => void;
}): JSX.Element => {
  useEffect(() => {
    // Force TextareaAutosize to remeasure layout after portal mount and animations
    // to prevent last line of pre-filled content from clipping
    const id = requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    return () => cancelAnimationFrame(id);
  }, []);

  const isMobile: boolean = useIsSmallMobile();

  return (
    <ModalPortal onClose={onClose} fullscreen={isMobile}>
      <ModalBody isPadded>
        <Styled.H3>{t('EAAdvocacyForm.EditYourMessage')}</Styled.H3>

        <MessageFields
          values={messageModalData.values}
          errors={messageModalData.errors}
          touched={messageModalData.touched}
          handleChange={messageModalData.handleChange}
          handleBlur={messageModalData.handleBlur}
          intro={messageModalData.intro}
          outro={messageModalData.outro}
        />

        <Styled.ButtonWrapper>
          <Styled.DoneButton big minContent onClick={onClose}>
            {t('EAAdvocacyForm.DoneReadingOrEditingYourMessage')}
          </Styled.DoneButton>
        </Styled.ButtonWrapper>
      </ModalBody>
    </ModalPortal>
  );
};
